import _defineProperty from "@babel/runtime/helpers/defineProperty";
import _objectWithoutProperties from "@babel/runtime/helpers/objectWithoutProperties";
var _excluded = ["isActive"];
function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }
function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }
// _           __   ___   _____    __   _   _   __   _   _____
// | |        / /  /   | |  _  \  |  \ | | | | |  \ | | /  ___|
// | |  __   / /  / /| | | |_| |  |   \| | | | |   \| | | |
// | | /  | / /  / / | | |  _  /  | |\   | | | | |\   | | |  _
// | |/   |/ /  / /  | | | | \ \  | | \  | | | | | \  | | |_| |
// |___/|___/  /_/   |_| |_|  \_\ |_|  \_| |_| |_|  \_| \_____/

// THIS FILE IS AUTO GENERATED!!!!!!
// DO NO EDIT IT HERE.

// THE TEMPLATE IS AT: tasks/pkg/icon-navigation-template-activatable/src/index.tsx
import React from 'react';
import baseIcon, { navigationActivatableDefaultStyleSheetGetter, defaultNavigationIconGroupProps, defaultNavigationIconShapeSize } from '@bubble-ui/temp-icon-base';
import useDeprecationWarning from '@bubble-ui/hook-use-deprecation-warning';
var NavigationIconHomePath = 'M25 21H23C22.449 21 22 20.552 22 20V8.612C22 8.308 22.136 8.024 22.373 7.833C22.563 7.68 22.801 7.593 23.035 7.612L24.796 7.979L25.212 6.022L23.637 5.68C23.531 5.657 23.426 5.64 23.32 5.629L22 5.354V0H16V4.104L1.204 1.021L0.786 2.977L2.214 3.29C2.669 3.39 3 3.801 3 4.267V20C3 20.552 2.551 21 2 21H0V23H25V21ZM20 8.612V20C20 20.351 20.061 20.687 20.171 21H15V16.88C15 15.842 13.881 15 12.5 15C11.119 15 10 15.842 10 16.88V21H4.829C4.939 20.687 5 20.351 5 20V4.267C5 4.125 4.99 3.985 4.97 3.849L20.426 7.068C20.15 7.528 20 8.06 20 8.612ZM20 4.937L18 4.521V2H20V4.937ZM12.5 13C13.604 13 14.5 12.104 14.5 11C14.5 9.896 13.604 9 12.5 9C11.396 9 10.5 9.896 10.5 11C10.5 12.104 11.396 13 12.5 13Z';
var NavigationIconHomeActivePath = 'M16.0002 2.061V0H21.9992V3.311L16.0002 2.061ZM10 16.879V20.999H15V16.879C15 15.841 13.881 14.999 12.5 14.999H12H11.484C10.734 14.999 10.059 14.577 9.722 13.897L8.563 11.556C8.318 11.06 7.718 10.856 7.223 11.103C6.728 11.349 6.525 11.948 6.771 12.442L7.93 14.784C8.378 15.688 9.129 16.358 10.022 16.713C10.0197 16.7346 10.0159 16.7559 10.0121 16.777C10.006 16.8106 10 16.844 10 16.879ZM14.5 10.999C14.5 9.895 13.604 8.999 12.5 8.999C11.396 8.999 10.5 9.895 10.5 10.999C10.5 12.103 11.396 12.999 12.5 12.999C13.604 12.999 14.5 12.103 14.5 10.999ZM22 8.611V19.999C22 20.551 22.449 20.999 23 20.999H25V22.999H0V20.999H2C2.551 20.999 3 20.551 3 19.999V4.266C3 3.8 2.669 3.389 2.214 3.289L0.786 2.976L1.204 1.02L23.32 5.628C23.426 5.639 23.531 5.656 23.637 5.679L25.212 6.021L24.796 7.978L23.035 7.611C22.801 7.579 22.562 7.68 22.373 7.832C22.136 8.023 22 8.307 22 8.611Z';
var NavigationIcon = baseIcon('NavigationIconHome', {
  getPath: _ref => {
    var {
      isActive
    } = _ref;
    return isActive ? NavigationIconHomeActivePath : NavigationIconHomePath;
  },
  styleSheetPropsGetter: (_ref2, designVersion) => {
    var {
      isActive,
      color,
      colorToken,
      colorTokenArgs
    } = _ref2;
    return {
      isActive,
      color,
      designVersion,
      colorToken,
      colorTokenArgs
    };
  },
  defaultStyleSheetGetter: navigationActivatableDefaultStyleSheetGetter,
  // eslint-disable-next-line @typescript-eslint/no-unused-vars
  restOfPropsSanitizer: _ref3 => {
    var {
        isActive
      } = _ref3,
      restOfProps = _objectWithoutProperties(_ref3, _excluded);
    return restOfProps;
  },
  groupProps: _objectSpread(_objectSpread({}, defaultNavigationIconGroupProps), {}, {
    x: 2,
    y: 3
  }),
  shapeSize: defaultNavigationIconShapeSize
});
var NavigationIconHome = props => {
  useDeprecationWarning({
    componentName: 'NavigationIconHome',
    removalDate: 'v6.0.0'
  });
  return /*#__PURE__*/React.createElement(NavigationIcon, props);
};
NavigationIconHome.displayName = 'NavigationIconHome';
export default NavigationIconHome;
//# sourceMappingURL=index.js.map